import { configureStore } from '@reduxjs/toolkit'
import authReducer from './features/auth/authSlice'
import analyticsReducer from './reducers/analyticsReducers'
import metaDataReducer from './reducers/metaReducsers';
import loansReducer from './reducers/loansReducers';

const store = configureStore({
  reducer: {
    auth: authReducer,
    analytics: analyticsReducer,
    metadata: metaDataReducer,
    loans: loansReducer
  },
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;

export default store;
